/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useEffect, useState, useRef } from 'react';
import cx from 'classnames';
import { ActionPopup, Icon, Text, Checkbox } from '../../../../../ui-kit';

import '../styles/_stock-asset-list-card.scss';













const stockAssetSourceTypes = [
'shutterstock'];


const disableContextMenu = (event) => {
  event.preventDefault();
};

function StockAssetsListCard({
  item,
  handleCardClick,
  handleOptionClick,
  handleCheckboxClick,
  checkedState,
  hideCardDetails,
  loading,
  shutterstockAccess
}) {
  const {
    id,
    description,
    duration,
    thumbnailUrl,
    thumbUrl,
    assetType,
    assetOrigin,
    contributor
  } = item;
  const [checked, setChecked] = useState(false);
  const [enableCheckbox, setEnableCheckbox] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);
  const [enableVideoHover, setEnableVideoHover] = useState(true);
  const [hoverVideoPlayerTimer, setHoverVideoPlayerTimer] = useState();
  const [percentageCompleted, setPercentageCompleted] = useState(0);
  const [enableScrub, setEnableScrub] = useState(true);
  const [scrubTime, setScrubTime] = useState(true);
  const videoPlayerRef = useRef();

  const [cardOptions] = useState([
  {
    action: () => handleOptionClick({ asset: item, type: 'details' }),
    label: 'Asset Details'
  },
  {
    action: () => handleOptionClick({ asset: item, type: 'add' }),
    label: 'Add to Project'
  }
  // {
  //   action: () => handleOptionClick({id: id, action:'favourite'}),
  //   label: 'Set as Favourite'
  // }
  ]);

  useEffect(() => {
    if (enableCheckbox) setChecked(checkedState);
  }, [checkedState]);

  useEffect(() => {
    if (loading) setEnableVideoHover(false);else
    {setEnableVideoHover(true);}
    setPercentageCompleted(0);
    setHoverVideoPlayerTimer(null);
    clearInterval(hoverVideoPlayerTimer);
    setPlayVideo(false);
  }, [loading]);

  useEffect(() => {
    setEnableVideoHover(true);
    return () => {
      clearInterval(hoverVideoPlayerTimer);
    };
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-param-reassign
    item.checkedState = checked;
    if (enableCheckbox) handleCheckboxClick(item);
    setEnableCheckbox(true);
    if (!shutterstockAccess) setChecked(false); // uncheck checkbox after call if no SS
  }, [checked]);

  const scrubVideoFrames = (event) => {
    if (!enableScrub) return;
    setEnableScrub(false);
    setTimeout(() => setEnableScrub(true), 100);
    const videoPlayer = videoPlayerRef.current;
    const videoPlayerBox = videoPlayer.getBoundingClientRect();
    const videoWidth = videoPlayerBox.width;
    const videoLeft = videoPlayerBox.left;
    const mousePos = event.clientX;
    let percentageLeft = parseFloat(((mousePos - videoLeft) / videoWidth * 100).toFixed(2));
    let timeScrub = (percentageLeft * videoPlayer.duration / 100).toFixed(1);
    if (timeScrub === 'NaN') timeScrub = 0;
    if (percentageLeft < 30) percentageLeft -= 5;
    if (percentageLeft > 60) percentageLeft += 5;
    setPercentageCompleted(percentageLeft.toFixed(2));
    setScrubTime(timeScrub);
    if (timeScrub < videoPlayer.duration) videoPlayer.currentTime = timeScrub;
  };

  return (
    <div
      key={id}
      className={cx('stock-asset-list-card', {
        'stock-asset-list-card--not-stock-asset-type': !stockAssetSourceTypes.includes(assetOrigin),
        'stock-asset-list-card--hide-card-details': hideCardDetails,
        'enable-asset-cards': enableVideoHover
      })}
      onContextMenu={disableContextMenu}>

      <div
        className="stock-asset-list-card__asset-body">

        {hideCardDetails &&

        <Checkbox
          checked={checked}
          onChange={() => setChecked(!checked)}
          style={{ zIndex: 10 }} />}



        {duration && <Text className="video-duration">{playVideo ? scrubTime : duration.toFixed(2)}</Text>}
        {playVideo &&

        <div
          className="stock-asset-list-card__asset-body__video-player"
          onClick={() => handleCardClick(item)}
          onMouseOut={() => setPlayVideo(false)}
          onBlur={() => setPlayVideo(false)}
          onMouseMove={scrubVideoFrames}>

            <div className="video-progress-bar" style={{ left: `${percentageCompleted}%` }} />
            <video ref={videoPlayerRef}>
              <source src={thumbUrl} type="video/mp4" />
              <track src="" kind="captions" srcLang="" label="" />
            </video>
          </div>}


        <div
          className="stock-asset-list-card__asset-body__image"
          data-testid="stock-assets-icon"
          style={{ background: `url(${thumbnailUrl})` }}
          onClick={() => handleCardClick(item)}
          onMouseOver={() => setPlayVideo(true)}
          onFocus={() => setPlayVideo(true)}>

          <Icon
            name={assetType === 'video' ? 'youtubedef' : 'image'}
            size={20}
            color="white"
            className="asset-type-icon" />

        </div>
        <div className="stock-asset-list-card__asset-body__details">
          <Icon
            name={assetOrigin}
            size={20}
            className="asset-origin-icon" />

          <Text className="stock-asset-list-card__asset-body__details__title">
            {description.substring(0, 22).trim()}
            ...
          </Text>
          <Text className="stock-asset-list-card__asset-body__details__contributor">
            Contributor:
            {' '}
            {contributor}
          </Text>
        </div>
        <div className="stock-asset-list-card__asset-body__asset-options-button">
          <ActionPopup
            className="asset-list-card__actions"
            options={cardOptions} />

        </div>
      </div>
    </div>);

}

export default StockAssetsListCard;